export default function Footer() {
  const footerLinks = [
    { label: '关于我们', href: '#about' },
    { label: '投稿爆料', href: '#contact' },
    { label: '常见问题', href: '#faq' },
    { label: '热度榜单', href: '#ranking' },
    { label: '最新快讯', href: '#updates' },
    { label: '移动端入口', href: '#app' },
  ];

  const handleClick = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-background-900">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <span className="text-xl font-bold text-background-50 whitespace-nowrap">
              51黑料吃瓜网
            </span>
            <p className="mt-3 text-sm text-foreground-300 leading-relaxed">
              51黑料吃瓜网官方入口，汇集全网最新黑料吃瓜内容。每日更新热门爆料、明星八卦、网络热点，黑料吃瓜网址一键直达，吃瓜网站首页实时推送。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-3">快速链接</h4>
            <ul className="space-y-2">
              {footerLinks.slice(0, 3).map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      handleClick(link.href);
                    }}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* More Links */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-3">热门板块</h4>
            <ul className="space-y-2">
              {footerLinks.slice(3).map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    onClick={(e) => {
                      e.preventDefault();
                      handleClick(link.href);
                    }}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Partners */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-3">合作伙伴</h4>
            <p className="text-sm text-foreground-400">优质合作伙伴持续入驻中</p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-foreground-800/40">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-foreground-400">
              &copy; {new Date().getFullYear()} 51黑料吃瓜网 - 51吃瓜官网全网最新资源，每日更新
            </p>
            <p className="text-xs text-foreground-500">
              本站内容均来自网络，仅供娱乐参考
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}